// extracted by mini-css-extract-plugin
export var container = "_ue-0";
export var table = "_ue-2";
export var tableWrapper = "_ue-1";